export interface IRouterParts
{
  [key:string]: string ;
}

function parts_of ( url:string )
{
  return url.split( '/' ) ;
}


function is_var ( part: string )
{
  return part.startsWith( ':' ) ;
}


function var_name ( part: string )
{
  return part.slice( 1 ) ;
}


export class Path<T>
{
  protected segments: string[][] ;
  protected vars: string[][] ;

  constructor ( segments: string[] )
  {
    this.segments = segments.map( url => parts_of( url ) ) ;
    this.vars     = segments.map( url => 
      parts_of( url ).filter( is_var ).map( var_name ) ) ;
  }


  is_valid ( url: string )
  {
     const values = parts_of( url ) ;

     for ( const seg of this.segments )
        {
           const values_for_this_segment = values.splice( 0, seg.length ) ;

           if ( !this.is_valid_segment( seg, values_for_this_segment ) )
                return false ;

           if ( !values.length )
                break ;
        }

     return values.length === 0 ;
  }


  is_valid_segment ( segment: string[], values: string[] )
  {
     return segment.length === values.length 
         && segment.reduce( (acc,part,i) => 
             acc && ( is_var( part ) || (part === values[ i ]) )
           , true ) ;
  }


  parse ( url: string )
  {
     const ret: any = { }
         , values   = parts_of( url ) ;

     for ( const seg of this.segments )
        {
           const values_for_this_segment = values.splice( 0, seg.length ) ;

           seg.forEach( (part,i) =>
           {
             if ( is_var( part ) )
                  ret[ var_name( part ) ] = values_for_this_segment[ i ] ;
           } ) ;
        }

     return ret as T ;
  }


  url ( values: T )
  {
     const ret : string[] = [] ;

     for ( let i = 0 ; i < this.segments.length ; ++ i )
     {
        const seg = this.segments[ i ] ;

        if ( !this.has_all_segment_values( this.vars[ i ], values ) )
             break ;

        seg.forEach( part =>
          ret.push( is_var( part )? (values as any)[ var_name( part ) ] : part ) ) ;
     }

     return ret.join( '/' ) ;
  }

  protected has_all_segment_values ( vars: string[], values: any )
  {
    return vars.reduce( (acc, var_name) => acc && values[ var_name ] !== undefined
                      , true ) ;
  }
}